export type RuntimeEnvLabel = "local" | "staging" | "live";

/** BE 타깃 환경 (파비콘·타이틀 결정용) */
export type BeTargetEnv = "staging" | "live";

const PROD_BE_HOSTS = [
  "gmchanger-prod.herokuapp.com",
] as const;

function isLocalHost(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "[::1]" ||
    hostname.endsWith(".local")
  );
}

function includesAnyHost(target: string, hosts: readonly string[]): boolean {
  return hosts.some((host) => target.includes(host));
}

export function detectRuntimeEnv(
  hostname: string,
  apiBaseUrl = "",
): RuntimeEnvLabel {
  if (isLocalHost(hostname)) return "local";
  if (includesAnyHost(apiBaseUrl, PROD_BE_HOSTS)) return "live";
  return "staging";
}

/**
 * BE 환경 판별 (파비콘·타이틀 결정용).
 * localhost에서는 VITE_PROXY_TARGET, 배포 환경에서는 VITE_API_BASE_URL 기반.
 */
export function detectBeTargetEnv(
  hostname: string,
  apiBaseUrl = "",
  proxyTarget = "",
): BeTargetEnv {
  if (isLocalHost(hostname)) {
    if (includesAnyHost(proxyTarget, PROD_BE_HOSTS)) return "live";
    return "staging";
  }
  if (includesAnyHost(apiBaseUrl, PROD_BE_HOSTS)) return "live";
  return "staging";
}

export function detectRuntimeEnvFromBrowser(): RuntimeEnvLabel {
  if (typeof window === "undefined") return "live";
  return detectRuntimeEnv(
    window.location.hostname,
    import.meta.env.VITE_API_BASE_URL ?? "",
  );
}

export function detectBeTargetEnvFromBrowser(): BeTargetEnv {
  if (typeof window === "undefined") return "live";
  return detectBeTargetEnv(
    window.location.hostname,
    import.meta.env.VITE_API_BASE_URL ?? "",
    import.meta.env.VITE_PROXY_TARGET ?? "",
  );
}
